import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Parametre } from '../models/parametre.model';

@Injectable({
  providedIn: 'root'
})
export class ParametreService {

  private apiUrl = 'https://be.festivalsousse.com/api/parametres';

  constructor(private http: HttpClient) { }

  getParametres(): Observable<Parametre> {
    return this.http.get<Parametre>(this.apiUrl);
  }

  updateParametres(parametres: Parametre): Observable<Parametre> {
    return this.http.put<Parametre>(this.apiUrl, parametres);
  }
}
